<template>
    <div>
        <CreateMedicine />
    </div>
</template>

<script>
import CreateMedicine from '@/components/medicine/CreateMedicine.vue';
export default {
    components: {
        CreateMedicine
    },
    name: 'MedicineCreate'
}
</script>